console.log('api_thread.js')

onmessage = function(ev) {
  // 文字列に変換した関数を復元
  const cb = new Function('data', ev.data.cb.replace(/^function cb\([a-z]+\)\s?{/, '').slice(0, -1))
  console.log(ev.data.url)
  // APIよりデータの取得
  fetch(ev.data.url)
    .then(res => {
      if (res.status == 404) {
        postMessage({
          type: 'error',
          data: res.statusText
        })
        return;
      }
      return res.json()
    })
    .then(res => {
        console.log('fetch:', ev.data.url, res);
        // 復元した関数の実行
        // 復元した関数内でpostmessageを行っているので、ここでは行っていない
        cb({
          api: res.data,
          post: ev.data
        });
      }
    )
    .catch(error => {
      postMessage({
        type: 'error',
        data: error
      })
    })
}
